import React from "react";

export const LOGO_SRC = "/images/brand/logo.jpg";

export const BrandMark = ({ size = 56, className = "" }) => (
  <div
    data-testid="brand-logo"
    className={`flex items-center justify-center rounded-2xl bg-white shadow-lg shadow-emerald-900/20 overflow-hidden ${className}`}
    style={{ width: size, height: size }}
  >
    <img src={LOGO_SRC} alt="U&URS NUTRITIONIST logo" className="w-full h-full object-contain" style={{ transform: "scale(1.15)" }} />
  </div>
);
